import React, { useState, useContext } from "react";
import { Context } from "..";
import { Budget } from "./Budget";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import BudgetFormModal from "./BudgetFormModal";
import { MonthsAbr } from "./dateConstants";
import { useTranslation } from "react-i18next";

const Budgets = () => {
  const [modalOpened, setModalOpened] = useState(false);
  const [now, setNow] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth())
  );
  const { budgets } = useContext(Context);

  const goToPreviousMonth = () => {
    const copy = new Date(now);
    copy.setMonth(copy.getMonth() - 1);
    setNow(copy);
  };
  const goToNextMonth = () => {
    const copy = new Date(now);
    copy.setMonth(copy.getMonth() + 1);
    setNow(copy);
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="flex items-center">
        <h1 className="text-3xl mr-8">💰 {t("Budgets")}</h1>
        <div
          onClick={goToPreviousMonth}
          className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer select-none"
        >
          <MdKeyboardArrowLeft />
        </div>
        <span className="mx-4 select-none">
          {MonthsAbr[now.getMonth()]} {now.getFullYear()}
        </span>
        <div
          onClick={goToNextMonth}
          className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer select-none"
        >
          <MdKeyboardArrowRight />
        </div>
      </div>
      <div className="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <div
          onClick={() => setModalOpened(true)}
          className="cursor-pointer p-10 border border-dashed border-gray-500 flex rounded-xl items-center justify-center"
        >
          + {t("Add Budget")}
        </div>
        {budgets[0].map((b) => (
          <Budget key={b.id} budget={b} monthDate={now} />
        ))}
      </div>

      {modalOpened && <BudgetFormModal onClose={() => setModalOpened(false)} />}
    </>
  );
};

export default Budgets;
